import { ProcurementDemandListTable } from "./components";

const ProcurementDemandList = ({
  selectedProducts,
  handleSelectedDemand,
  demandIds,
  demands,
}: {
  selectedProducts: any;
  handleSelectedDemand: (id: number) => void;
  demandIds: number[];
  demands: any; //!!! any
}) => {
  return (
    <div className="d-flex flex-column gap-10 pt-10">
      <ProcurementDemandListTable
        selectedProducts={selectedProducts}
        handleSelectedDemand={handleSelectedDemand}
        demandIds={demandIds}
        demands={demands}
      />
    </div>
  );
};

export default ProcurementDemandList;
